import React from 'react';
import PropTypes from 'prop-types';
import './TaskBudget.css';
import CheckBox from 'components/shared/checkbox/CheckBox';
import ComplexNumberInput from 'components/shared/input/ComplexNumberInput';

export default function TaskBudget(props) {
  const handleInputBlur = (valueKey, value) => {
    if (props.onValueBlur !== undefined) {
      props.onValueBlur(valueKey, value);
    }
  };

  const handleInputChange = (valueKey, value) => {
    if (props.onValueChange !== undefined) {
      props.onValueChange(valueKey, value);
    }
  };

  const showCheck = props.withCheck !== undefined;
  return (
    <div className="task-budget">
      <table>
        <colgroup>
          <col />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <td>
              {showCheck && (
                <div className="with-check-box">
                  <CheckBox
                    id={props.withCheck.id}
                    checked={props.withCheck.checked}
                    shape="round"
                    size="medium"
                    onChange={props.withCheck.onCheck}
                  />
                </div>
              )}
              <div
                className={showCheck ? 'with-check-text' : ''}
              >{`Task # ${props.taskNumber}`}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div className={showCheck ? 'with-check-text' : ''}>
                {props.taskTrade}
              </div>
            </td>
            <td>
              <ComplexNumberInput
                label="Cost"
                theme="blue"
                value={props.values['cost']}
                onValueBlur={(value) => handleInputBlur('cost', value)}
                onValueChange={(value) => handleInputChange('cost', value)}
              />
            </td>
          </tr>
          {props.showValues && (
            <tr>
              <td colSpan={2}>
                <ComplexNumberInput
                  label="Markup"
                  value={props.values['markup']}
                  onValueBlur={(value) => handleInputBlur('markup', value)}
                  onValueChange={(value) => handleInputChange('markup', value)}
                />
                <ComplexNumberInput
                  label="Fee"
                  value={props.values['fee']}
                  onValueBlur={(value) => handleInputBlur('fee', value)}
                  onValueChange={(value) => handleInputChange('fee', value)}
                />
                <ComplexNumberInput
                  label="Insurance"
                  value={props.values['insurance']}
                  onValueBlur={(value) => handleInputBlur('insurance', value)}
                  onValueChange={(value) =>
                    handleInputChange('insurance', value)
                  }
                />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

TaskBudget.propTypes = {
  showValues: PropTypes.bool,
  taskNumber: PropTypes.number.isRequired,
  taskTrade: PropTypes.string.isRequired,
  values: PropTypes.shape({
    cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    insurance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    markup: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  withCheck: PropTypes.shape({
    id: PropTypes.number.isRequired,
    checked: PropTypes.bool.isRequired,
    onCheck: PropTypes.func.isRequired,
  }),
  onValueBlur: PropTypes.func,
  onValueChange: PropTypes.func,
};

TaskBudget.defaultProps = {
  showValues: true,
  values: {
    cost: null,
    fee: null,
    insurance: null,
    markup: null,
  },
};



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/budget/TaskBudget.js